import { render, staticRenderFns } from "./CreativePreview.vue?vue&type=template&id=328a08ea&"
import script from "./CreativePreview.vue?vue&type=script&lang=ts&"
export * from "./CreativePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports